import { useCallback, useEffect, useState } from 'react';
import { db } from "../common/firebase";

function Index() {
    let userId = "";
    let passwd = "";

    const fetchData = useCallback(() => {
        // 받아온 데이터를 저장할 배열
        let tasksData = [];
    
        // firestore.js에서 가져온 firestore 객체
        db.collection("admin") //  "tasks" 컬렉션 반환
            .get() // "tasks" 컬렉션의 모든 다큐먼트를 갖는 프로미스 반환
            .then((docs) => {
            // forEach 함수로 각각의 다큐먼트에 함수 실행
            docs.forEach((doc) => {
                // data(), id로 다큐먼트 필드, id 조회
                tasksData.push({ userId: doc.data().id, passwd: doc.data().passwd, id: doc.id });
                console.log(doc.data().id, doc.data().passwd)
            });
            console.log(tasksData[0])
            userId = tasksData[0].userId;
            passwd = tasksData[0].passwd;
        });
    }, []);
    
    // 최초 렌더링 이후에 실행하기 위해 useEffect 내부에서 함수 실행
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
        <section class="page-section" id="contact">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">관리자</h2>
                </div>
                
                <form id="contactForm" data-sb-form-api-token="API_TOKEN">
                    <div class="row align-items-stretch mb-5">
                        <div class="col-md-3"></div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <input class="form-control" id="userId" type="text" placeholder="아이디" data-sb-validations="required" />
                                <div class="invalid-feedback" data-sb-feedback="name:required">A name is required.</div>
                            </div>
                            <div class="form-group">
                                <input class="form-control" id="userPw" type="password" placeholder="비밀번호" data-sb-validations="required,email" />
                            </div>
                        </div>
                    </div>
                    
                    <div class="d-none" id="submitSuccessMessage">
                        <div class="text-center text-white mb-3">
                            <div class="fw-bolder">Form submission successful!</div>
                            To activate this form, sign up at
                            <br />
                            <a href="https://startbootstrap.com/solution/contact-forms">https://startbootstrap.com/solution/contact-forms</a>
                        </div>
                    </div>
                    
                    <div class="d-none" id="submitErrorMessage"><div class="text-center text-danger mb-3">Error sending message!</div></div>
                    
                    <div class="text-center"><button class="btn btn-primary btn-xl text-uppercase" id="submitBtn" type="submit">로그인</button></div>
                </form>
            </div>
        </section>
        </>
    )
}

export default Index;